export const APP_NAME = 'Courier app'
